module.exports = __webpack_public_path__ + "static/w_onama_img-88f72cb865982564b16299d132f79535.jpg";